
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/memberships/cbauto/absolute-advantage",
      function () {
        return require("private-next-pages/memberships/cbauto/absolute-advantage.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/memberships/cbauto/absolute-advantage"])
      });
    }
  